import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "userDashboard" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "name" }, null, -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_loyalty-point" }, null, -1)
const _hoisted_5 = { class: "whiteBoxInfo" }
const _hoisted_6 = { class: "boxShadow" }
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_user" }, null, -1)
const _hoisted_9 = { class: "content" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide" }, null, -1)
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "grayBoxInfo" }
const _hoisted_13 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_14 = {
  key: 0,
  class: "boxMessage"
}
const _hoisted_15 = { class: "eventCard" }
const _hoisted_16 = { class: "content" }
const _hoisted_17 = { class: "primaryColor" }
const _hoisted_18 = {
  key: 0,
  class: "title"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)
const _hoisted_21 = { class: "when" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_SidebarUserWrapper = _resolveComponent("SidebarUserWrapper")!

  return (_ctx.user)
    ? (_openBlock(), _createBlock(_component_SidebarUserWrapper, {
        key: 0,
        title: _ctx.$t('user.my_super_city'),
        sidebarComponent: _ctx.sidebarComponent,
        name: _ctx.user.first_name + ' ' + _ctx.user.last_name
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            (_ctx.loyaltyEnabled && _ctx.user.loyalty)
              ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.$t("my_super_city.points")) + ": ", 1),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.loyaltyPoints) + " ", 1),
                  _hoisted_4
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ProgressBar, {
                      value: _ctx.calculateAccountCompletion()
                    }, null, 8, ["value"]),
                    _createElementVNode("span", null, _toDisplayString(_ctx.calculateAccountCompletion()) + " " + _toDisplayString(_ctx.$t("my_super_city.profile_power")), 1)
                  ])
                ])
              ])
            ]),
            _hoisted_10,
            _createElementVNode("h2", _hoisted_11, _toDisplayString(_ctx.$t("my_super_city.activity")), 1),
            _createElementVNode("div", _hoisted_12, [
              (_ctx.activities.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.$t("global.no_data")), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (_ctx.checkActivityParameter(item.parameter))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("i", {
                          class: _normalizeClass([_ctx.getActivityIcon(item), "absolute"])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("small", _hoisted_17, _toDisplayString(_ctx.getActivityText(item.activity)), 1),
                            (item.parameter)
                              ? (_openBlock(), _createElementBlock("h3", _hoisted_18, _toDisplayString(_ctx.getParameterText(item.parameter)), 1))
                              : _createCommentVNode("", true),
                            (
                    item.parameter &&
                    !(
                      item.previous_value === null &&
                      item.current_value === null
                    )
                  )
                              ? (_openBlock(), _createElementBlock("small", _hoisted_19, [
                                  _createTextVNode(_toDisplayString(_ctx.getActivityValue(item.previous_value)) + " ", 1),
                                  _hoisted_20,
                                  _createTextVNode(" " + _toDisplayString(_ctx.getActivityValue(item.current_value)), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$moment.utc(item.created_at).local().format("DD.MM.YYYY HH:mm")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }, 8, ["title", "sidebarComponent", "name"]))
    : _createCommentVNode("", true)
}